import { Game } from './Game';
import { Input } from './Input';
import { Audio } from './Audio';
import { normalizeBoard } from './BoardPack.mjs';
import { ReplayPracticeSession } from './ReplayEngine';

const $ = id => document.getElementById(id);

export const TestUI = {
    init(workshop) {
        this.workshop = workshop;
        $('test-return').onclick = () => {
            const { returnView, returnFocus } = this.active;
            workshop.show(returnView);
            $(returnFocus)?.focus();
        };
        $('test-restart').onclick = () => this.restart();
        $('test-resume').onclick = () => {
            if (Game.session && !Game.session.testResult) Game.session.paused = false;
            Input.consume(true);
            if (this.active?.replay) $('test-resume').textContent = 'Resume practice';
            $('canvas').focus();
        };
    },

    start(board, { returnView = 'workshop', returnLabel = 'Return to editing', returnFocus = 'test-board', context = 'Custom draft' } = {}) {
        if (!Game.ready) return;
        const snapshot = normalizeBoard(board);
        if (this.active) this.leave();
        this.active = { board: snapshot, returnView, returnFocus, returnLabel, session: Game.session, menu: Game.menu };
        if (Game.session) Game.session.paused = true;
        $('test-mode').textContent = 'BOARD TEST';
        $('test-restart').textContent = 'Restart test';
        $('test-resume').textContent = 'Resume test';
        $('test-title').textContent = snapshot.name;
        $('test-context').textContent = context;
        $('test-return').textContent = `← ${returnLabel}`;
        $('test-screen').append($('canvas'));
        this.workshop.show('test');
        this.restart();
        window.scrollTo(0, 0);
    },

    startReplay(snapshot, { context, elapsedMs = 0, onLeave } = {}) {
        if (!Game.ready) return;
        // Validate before changing any live session or view.
        new ReplayPracticeSession(snapshot, { elapsedMs });
        if (this.active) this.leave();
        this.active = { replay: structuredClone(snapshot), elapsedMs, onLeave, returnView: 'replays',
            returnLabel: 'Return to recording', returnFocus: 'replay-takeover', session: Game.session, menu: Game.menu };
        if (Game.session) Game.session.paused = true;
        $('test-mode').textContent = 'REPLAY PRACTICE';
        $('test-title').textContent = snapshot.state.name;
        $('test-context').textContent = context;
        $('test-return').textContent = '← Return to recording';
        $('test-restart').textContent = 'Retry from here';
        $('test-screen').append($('canvas'));
        this.workshop.show('test');
        this.restart();
        window.scrollTo(0, 0);
    },

    restart() {
        if (!this.active) return;
        if (this.active.replay) { this.restartReplay(); return; }
        Audio.readyToPlay = true;
        Audio.ctx.resume();
        $('test-status').textContent = 'Reach a treasure to complete this test. Your saved board stays unchanged.';
        $('test-status').classList.remove('test-complete');
        $('test-resume').disabled = false;
        Game.startSession([this.active.board], { testing: true, onTestEnd: result => {
            $('test-status').textContent = result === 'completed'
                ? `Board completed! ${this.active.returnLabel} or restart to try another route.`
                : 'Test ended — no lives remaining. Restart to try again, or return to your board.';
            $('test-status').classList.toggle('test-complete', result === 'completed');
            $('test-resume').disabled = true;
        } });
        $('canvas').focus();
    },

    restartReplay() {
        const active = this.active;
        const session = new ReplayPracticeSession(active.replay, { elapsedMs: active.elapsedMs, onTestEnd: result => {
            $('test-status').textContent = result === 'completed'
                ? 'Board completed! Retry from this moment or return to the recording.'
                : 'Attempt ended. Retry from this moment or rewind the recording to try a different approach.';
            $('test-status').classList.toggle('test-complete', result === 'completed');
            $('test-resume').disabled = true;
        } });
        Game.stopRecording?.('Practice restarted');
        Input.consume(true);
        Audio.readyToPlay = true;
        Audio.ctx.resume();
        Game.menu = undefined;
        Game.session = session;
        $('test-resume').textContent = 'Start playing';
        $('test-resume').disabled = false;
        $('test-status').classList.remove('test-complete');
        $('test-status').textContent = 'Ready at the selected moment. Choose Start playing or press Enter. This practice attempt ends at the treasure or when you lose a life; no high scores.';
        Game.onSessionStart?.();
        $('canvas').focus();
    },

    leave() {
        if (!this.active) return;
        Game.stopRecording?.('Left board test');
        // Restore the previous campaign/menu without replacing its score or field.
        Game.session = this.active.session;
        Game.menu = this.active.menu;
        if (Game.session) Game.session.paused = true;
        $('play-screen').append($('canvas'));
        const onLeave = this.active.onLeave;
        this.active = undefined;
        Input.consume(true);
        onLeave?.();
    }
};
